const exampleCallbackFile = crm => ({ fieldName, compField, compIndex, eventName, subscriber, staticArgs, dispatchWrapper, getState }) => {
	console.log({ crm, fieldName, compField, compIndex, eventName, subscriber, staticArgs, dispatchWrapper, getState });
};

export default exampleCallbackFile;
